<template>
  <div>
    Intermediary
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>
